import * as React from "react"

import { cn } from "../../cn"

type AccessibleName =
  | { "aria-label": string; "aria-labelledby"?: string }
  | { "aria-label"?: string; "aria-labelledby": string }

export type ProgressProps = React.HTMLAttributes<HTMLDivElement> &
  AccessibleName & {
    value?: number
    max?: number
  }

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => {
    const safeMax = Math.max(max, 1)
    const clampedValue = Math.min(Math.max(value, 0), safeMax)
    const percentage = (clampedValue / safeMax) * 100

    return (
      <div
        ref={ref}
        {...props}
        role="progressbar"
        aria-valuenow={clampedValue}
        aria-valuemin={0}
        aria-valuemax={safeMax}
        className={cn(
          "relative w-full overflow-hidden rounded-full bg-surface-1 h-1",
          className,
        )}
      >
        <div
          className="h-full rounded-full bg-coval-info-border transition-[width] duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    )
  },
)

Progress.displayName = "Progress"

export { Progress }
